import { AssetUIModel, StepperModel, WidthClass } from '@thehubz/client/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { StepperConfig } from '../../models/stepper-config.interface';

export const newAssetVersionStepperConfig = (assetInfo: AssetUIModel, users: UserInfo[], tags: string[] = [], stepperConfig?: StepperConfig): StepperModel => ({
  stepID: 'newVersion',
  stepLabel: $localize`New version`,
  stepper: [
    {
      stepperId: '1',
      stepperName: $localize`Upload assets`,
      stepperGroupName: 'uploadAssets',
      selected: true,
      visited: true,
      formFields: [
        {
          formTypeId: '1',
          formFieldName: 'assetData',
          fieldType: 'uploadFiles',
          fieldLabel: $localize`Asset upload`,
          placeholder: $localize`Asset upload`,
          widthClass: WidthClass.WFull,
          validators: {
            required: true,
          },
          visible: true,
          multipleFile: false,
        },
      ],
      actions: [
        {
          actionLabel: $localize`:action:Add new version`,
          actionTypePosition: 'right',
          actionType: 'createVersion',
          icon: '',
          alignIcon: 'right',
          disable: false,
          visible: false,
        },
      ],
    },
  ],
});
